import angular from 'angular';
import constants from 'app/constants';
import {
  ssDialogService
} from 'app/services';
import controller from './view-contacts-dialog.controller';
import template from './view-contacts-dialog.html';


class dialogService {
  getOptions($event, { vendor, product }) {
    return {
      controller,
      controllerAs: 'viewContactsDialogVM',
      locals: {
        vendor,
        product
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.viewContactsDialog', [
  constants,
  ssDialogService,
])
  .service('viewContactsDialog', dialogService)
  .name;
